module.exports = __webpack_public_path__ + "img/mobile-icon14.58fb2b4f.svg";